module.exports = __webpack_public_path__ + "static/media/GS75-label.52a317b1.png";